let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1rSZn")).then(() => parcelRequire('bkE5u'));